import { Box } from '@chakra-ui/react';
import { Link, useLocation } from "react-router-dom";
import routes from '../../pages/routes';



const HelpdeskSideNav = () => {
    const location = useLocation()

    const activeLink = (link: string) => {
        const style = {

            borderColor: 'white',
            borderLeft: '',
            bgColor: 'white',
            textColor: '#9E9E9E'
        };

        if (link === location.pathname) {
            style.borderColor = "#EC3337";
            style.borderLeft = '3px Solid';
            style.bgColor = '#FFFAFA';
            style.textColor = ' #EC3337'
        }

        return style;
    };
    return (
        <Box py='40px' fontSize="14px" bg='white' mr='30px' minHeight='225px' height='fit-content' width="16rem">
            <Box pl='40px' mb='20px' pr='20px' borderLeft={activeLink(routes.HomeHelpdesk).borderLeft}
                borderColor={activeLink(routes.HomeHelpdesk).borderColor}
                bg={activeLink(routes.HomeHelpdesk).bgColor}
                color={activeLink(routes.HomeHelpdesk).textColor} lineHeight={10} fontWeight='500' >
                <Link to={routes.HomeHelpdesk}>Help Desk Home </Link>
            </Box>
            <Box pl='40px' mb='20px' pr='20px' borderLeft={activeLink(routes.HelpdeskNewRequest).borderLeft}
                borderColor={activeLink(routes.HelpdeskNewRequest).borderColor}
                bg={activeLink(routes.HelpdeskNewRequest).bgColor}
                color={activeLink(routes.HelpdeskNewRequest).textColor} lineHeight={10} fontWeight='500'>
                <Link to={routes.HelpdeskNewRequest}>New Help Request</Link>
            </Box>
            {/* <Box pl='40px' mb='20px' pr='20px' borderLeft={activeLink(routes.HelpdeskTrackRequest).borderLeft}
                borderColor={activeLink(routes.HelpdeskTrackRequest).borderColor}
                bg={activeLink(routes.HelpdeskTrackRequest).bgColor}
                color={activeLink(routes.HelpdeskTrackRequest).textColor} lineHeight={10} fontWeight='500'>
                <Link to={routes.HelpdeskTrackRequest}>Track Help Request</Link>
            </Box> */}
            <Box pl='40px' mb='20px' pr='20px' borderLeft={activeLink(routes.PaymentGuidelines).borderLeft}
                borderColor={activeLink(routes.PaymentGuidelines).borderColor}
                bg={activeLink(routes.PaymentGuidelines).bgColor}
                color={activeLink(routes.PaymentGuidelines).textColor} lineHeight={10} fontWeight='500'>
                <Link to={routes.PaymentGuidelines}> Payment Guideline</Link>
            </Box>
        </Box>
    )
}

export default HelpdeskSideNav